module.exports = __webpack_public_path__ + "media/images/icon_list/warning-0f11a3f1c1bec0bfe8ae6968f37945db.svg";